import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@lawline/ui/components/table";
import { useTranslations } from "use-intl";

import { formatTokens } from "../usage.utils";

export interface BreakdownRow {
	id: string;
	label: string;
	requests: number;
	tokens: number;
	lawline: number;
}

interface UsageBreakdownTableProps {
	head: string;
	rows: BreakdownRow[];
	empty: string;
}

export function UsageBreakdownTable({ head, rows, empty }: UsageBreakdownTableProps) {
	const t = useTranslations("usage.breakdown.columns");

	if (rows.length === 0)
		return (
			<p className="text-muted-foreground flex h-20 items-center justify-center text-sm">{empty}</p>
		);

	return (
		<div className="overflow-hidden rounded-md border">
			<Table>
				<TableHeader>
					<TableRow>
						<TableHead>{head}</TableHead>
						<TableHead className="text-right">{t("requests")}</TableHead>
						<TableHead className="text-right">{t("tokens")}</TableHead>
						<TableHead className="text-right">{t("lawlineTokens")}</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{rows.map((r) => (
						<TableRow key={r.id}>
							<TableCell className="font-medium">{r.label}</TableCell>
							<TableCell className="text-right font-mono tabular-nums">
								{formatTokens(r.requests)}
							</TableCell>
							<TableCell className="text-right font-mono tabular-nums">
								{formatTokens(r.tokens)}
							</TableCell>
							<TableCell className="text-right font-mono tabular-nums">
								{formatTokens(r.lawline)}
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
}
